import type { OrgEmployeeRequest } from '@api/OrgEmployeeRequestService';
import { useOrgEmployeeRequestEntry } from '@stores/orgEmployeeRequestStore';

const useOrgEmployeeRequest = (
    orgId: string,
    orgEmployeeId: string,
    requestId: string,
): {
    orgEmployeeRequest: OrgEmployeeRequest | undefined;
    isLoadingOrgEmployeeRequest: boolean;
    fetchOrgEmployeeRequest: () => void;
} => {
    const {
        response: orgEmployeeRequest,
        isLoading: isLoadingOrgEmployeeRequest,
        requestApiCall: fetchOrgEmployeeRequest,
    } = useOrgEmployeeRequestEntry(orgId, orgEmployeeId, requestId);

    return {
        orgEmployeeRequest,
        isLoadingOrgEmployeeRequest,
        fetchOrgEmployeeRequest,
    };
};

export default useOrgEmployeeRequest;
